/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { AdvCommentList } from '@components/AdvComment/AdvCommentList'
import { FROM_VIEW_TYPE, USER_COMMENT_TYPE } from '@v2/constants/common'
import { Schema$UserComment } from '@interface/comment'

interface AdvCommentProp {
  commentType: USER_COMMENT_TYPE
  fromViewType: FROM_VIEW_TYPE
  targetId: string // 프리미엄 분석가, 나도승부사 분석글 아이디
  callbackCreated?: (comment: Schema$UserComment) => void
  callbackUpdated?: (comment: Schema$UserComment) => void
  callbackDeleted?: (comment: Schema$UserComment) => void
  callbackLiked?: (comment: Schema$UserComment) => void
}

export const AdvComment: React.FC<AdvCommentProp> = observer((props) => {
  const {
    commentType, fromViewType,
    targetId,
    callbackCreated, callbackUpdated, callbackDeleted, callbackLiked,
  } = props

  return (
    <Fragment>
      <AdvCommentList
        commentType={commentType}
        targetId={targetId}
        callbackCreated={callbackCreated}
        callbackUpdated={callbackUpdated}
        callbackDeleted={callbackDeleted}
        callbackLiked={callbackLiked}
        fromViewType={fromViewType}
      />
    </Fragment>
  )
})
